import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import OutlinedButton from '../../ui/OutlinedButton/OutlinedButton'
import classes from './UserEntitlements.module.scss'
import messages from './module/messages'
import filterMessages from '../../translations/filterMessages'
import Panel from '../../ui/Panel/Panel'
import FilterTable from '../../components/FilterTable/FilterTable'
import { Collapse } from '@mui/material'
import Table from '../../components/Table/Table'
import { push } from 'connected-react-router'
import {
  IDENTITY_SYSTEM,
  IDENTITY_SYSTEM_LIST,
  IdentitySystemType,
  ROUTES,
} from '../../module/constants'
import { IUserEntitlementsProps } from './module/constants'
import { isEmpty } from 'ramda'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import {
  selectUserEntitlementList,
  selectUserEntitlementLoader,
} from './module/selector'
import { fetchUserEntitlementRequestAction } from './module/actions'
import CustomModal from '../../components/Modals/CustomModal/CustomModal'
import {
  ISectionType,
  ITableType,
} from '../../common/TablesConfiguration/tcConstants'

const form = 'userEntitlementsFormFilter'

const TypeFilter = {
  identitySystemIdFilter: 'identitySystemId',
  entitlementFilter: 'entitlement_name',
  entitlementDescriptionFilter: 'entitlement_description',
  applicationFilter: 'application_name',
  applicationDescriptionFilter: 'application_description',
}

function UserEntitlements({
  entitlementList,
  loader,
  goBack,
  userEntitlementsRequest,
}: IUserEntitlementsProps) {
  const [filter, setFilter] = useState<any>([])
  const [businessroleEntitlements, setBusinessroleEntitlements] = useState<any>(
    []
  )

  useEffect(() => {
    userEntitlementsRequest()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSubmit: any = (values: any = {}) => {
    const { advancedSearchFilter, allFilter = '', ...rest } = values
    let valueFilter: any[] = []
    if (values && isEmpty(values)) return setFilter([])

    if (advancedSearchFilter) {
      if (!isEmpty(rest)) {
        Object.keys(rest).forEach((element: any) => {
          valueFilter.push({
            id: TypeFilter[element as keyof typeof TypeFilter],
            value:
              element === 'identitySystemIdFilter'
                ? IDENTITY_SYSTEM[rest[element] as keyof typeof IDENTITY_SYSTEM]
                : rest[element],
            operation: 'AND',
          })
        })
      }
    } else {
      valueFilter = [
        {
          id: 'application_name',
          value: allFilter,
          operation: 'OR',
        },
        {
          id: 'entitlement_name',
          value: allFilter,
          operation: 'OR',
        },
      ]
    }
    setFilter(valueFilter)
  }

  const handleInfoBR = (id: string, row: any) => {
    const entitlementsTemp = row.original.entitlements
      ? row.original.entitlements
      : []
    setBusinessroleEntitlements(entitlementsTemp)
  }

  return (
    <div>
      <CustomModal
        show={businessroleEntitlements && businessroleEntitlements.length > 0}
        title={<FormattedMessage {...messages.businessRoleEntitlements} />}
        onClose={() => setBusinessroleEntitlements([])}
        size="xl"
        dataSource={businessroleEntitlements}
      />
      <div className={classes.actionsTop}>
        <OutlinedButton onClick={() => goBack()}>
          <FormattedMessage {...messages.goBack} />
        </OutlinedButton>
      </div>
      <Collapse in={true}>
        <Panel
          loader={loader}
          title={<FormattedMessage {...messages.entitlements} />}
        >
          <FilterTable
            messages={{ ...filterMessages, ...messages }}
            formProps={form}
            listsFilter={{
              IDENTITY_SYSTEM_LIST: {
                list: IDENTITY_SYSTEM_LIST,
                type: IdentitySystemType,
              },
            }}
            onSubmitProps={(val: any) => onSubmit(val)}
            advancedFilter={true}
            isAccordion={true}
          />
          {entitlementList.length > 0 ? (
            <Table
              filterProps={filter}
              dataSource={entitlementList}
              areRowDeletable={false}
              rowsChangeable
              showBrInfo
              isBR
              onInfoBR={(id: string, row: any) => handleInfoBR(id, row)}
              sectionType={ISectionType.USER_ENTITLEMENTS}
              tableType={ITableType.ENTITLEMENTS_TABLE}
            />
          ) : (
            <></>
          )}
          {}
          {entitlementList?.length === 0 ? (
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-center">
              <FormattedMessage {...messages.emptyTable} />
            </div>
          ) : (
            <></>
          )}
        </Panel>
      </Collapse>
      <div className={classes.actionsBottom}>
        <OutlinedButton onClick={() => goBack()}>
          <FormattedMessage {...messages.goBack} />
        </OutlinedButton>
      </div>
    </div>
  )
}

const mapStateToProps: any = () =>
  createStructuredSelector({
    loader: selectUserEntitlementLoader,
    entitlementList: selectUserEntitlementList,
  })

const mapDispatchToProps: any = {
  userEntitlementsRequest: fetchUserEntitlementRequestAction,
  goBack: () => push(ROUTES.WELCOME),
}

const withConnect: any = connect(mapStateToProps, mapDispatchToProps)

export default withConnect(UserEntitlements)
